<template>
    <CRow>
        <CCol>
            <CCard>
                <!-- <CCardHeader>
          <strong>Статусы</strong>
        </CCardHeader> -->
                <CCardBody>
                    <CForm>
                        <CRow class="w-100 mb-2">
                            <CCol>
                                <CInput
                                    v-model="statuses.submited"
                                    label="Подтверждение/Оформление"
                                    class="m-0"
                                    horizontal
                                />
                            </CCol>
                            <CCol col="1" class="m-0 d-flex align-items-center">
                                <CSwitch
                                    color="success"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="statuses.submited_enabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="w-100 mb-2">
                            <CCol>
                                <CInput
                                    v-model="statuses.in_work"
                                    label="В работе"
                                    class="m-0"
                                    horizontal
                                />
                            </CCol>
                            <CCol col="1" class="m-0 d-flex align-items-center">
                                <CSwitch
                                    color="success"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="statuses.in_work_enabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="w-100 mb-2">
                            <CCol>
                                <CInput
                                    v-model="statuses.prepared"
                                    label="Оплата"
                                    class="m-0"
                                    horizontal
                                />
                            </CCol>
                            <CCol col="1" class="m-0 d-flex align-items-center">
                                <CSwitch
                                    color="success"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="statuses.prepared_enabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="w-100 mb-2">
                            <CCol>
                                <CInput
                                    v-model="statuses.paid"
                                    label="Оплачен"
                                    class="m-0"
                                    horizontal
                                />
                            </CCol>
                            <CCol col="1" class="m-0 d-flex align-items-center">
                                <CSwitch
                                    color="success"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="statuses.paid_enabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="w-100 mb-2">
                            <CCol>
                                <CInput
                                    v-model="statuses.awaiting"
                                    label="Собираем/Готовим"
                                    class="m-0"
                                    horizontal
                                />
                            </CCol>
                            <CCol col="1" class="m-0 d-flex align-items-center">
                                <CSwitch
                                    color="success"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="statuses.awaiting_enabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="w-100 mb-2">
                            <CCol>
                                <CInput
                                    v-model="statuses.awaiting_ready"
                                    label="Заказ готов"
                                    class="m-0"
                                    horizontal
                                />
                            </CCol>
                            <CCol col="1" class="m-0 d-flex align-items-center">
                                <CSwitch
                                    color="success"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="statuses.awaiting_ready_enabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="w-100 mb-2">
                            <CCol>
                                <CInput
                                    v-model="statuses.delivery"
                                    label="Курьер"
                                    class="m-0"
                                    horizontal
                                />
                            </CCol>
                            <CCol col="1" class="m-0 d-flex align-items-center">
                                <CSwitch
                                    color="success"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="statuses.delivery_enabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="w-100 mb-2">
                            <CCol>
                                <CInput
                                    v-model="statuses.delivery_concierge"
                                    label="Консьерж"
                                    class="m-0"
                                    horizontal
                                />
                            </CCol>
                            <CCol col="1" class="m-0 d-flex align-items-center">
                                <CSwitch
                                    color="success"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="statuses.delivery_concierge_enabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="w-100 mb-2">
                            <CCol>
                                <CInput
                                    v-model="statuses.meeting_point"
                                    label="В точке встречи"
                                    class="m-0"
                                    horizontal
                                />
                            </CCol>
                            <CCol col="1" class="m-0 d-flex align-items-center">
                                <CSwitch
                                    color="success"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="statuses.meeting_point_enabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="w-100 mb-2">
                            <CCol>
                                <CInput
                                    v-model="statuses.done"
                                    label="Выполнен"
                                    class="m-0"
                                    horizontal
                                />
                            </CCol>
                            <CCol col="1" class="m-0 d-flex align-items-center">
                                <CSwitch
                                    color="success"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="statuses.done_enabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="w-100 mb-2">
                            <CCol>
                                <CInput
                                    v-model="statuses.canceled"
                                    label="Отменен"
                                    class="m-0"
                                    horizontal
                                />
                            </CCol>
                            <CCol col="1" class="m-0 d-flex align-items-center">
                                <CSwitch
                                    color="success"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="statuses.canceled_enabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="w-100 mb-2">
                            <CCol>
                                <CInput
                                    v-model="statuses.incedent"
                                    class="m-0"
                                    label="Инцидент"
                                    horizontal
                                />
                            </CCol>
                            <CCol col="1" class="m-0 d-flex align-items-center">
                                <CSwitch
                                    color="success"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="statuses.incedent_enabled"
                                />
                            </CCol>
                        </CRow>

                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Назад</CButton>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="saveSettings"
                    >Сохранить</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    export default {
        name: 'EntityStatuses',

        props: {
            entity: {
                type: Object,
                default: () => ({})
            }
        },

        data: () => ({
            statuses: {
                submited: '',
                submited_enabled: true,
                paid: '',
                paid_enabled: true,
                awaiting: '',
                awaiting_enabled: true,
                delivery: '',
                delivery_enabled: true,
                done: '',
                done_enabled: true,
                canceled: '',
                canceled_enabled: true,
                incedent: '',
                incedent_enabled: true,
                prepared: '',
                prepared_enabled: true,
                in_work: '',
                in_work_enabled: true,
                awaiting_ready: '',
                awaiting_ready_enabled: true,
                delivery_concierge: '',
                delivery_concierge_enabled: true,
                meeting_point: '',
                meeting_point_enabled: true,
            }
        }),

        computed: {},

        watch: {
            entity() {
                if (this.entity.statuses) {
                    this.statuses = this.entity.statuses;
                }
            }
        },

        mounted() {},

        methods: {
            async saveSettings() {
                try {
                    await this.axios.post(`/entities/${this.entity.id}/dictionary/statuses`, this.statuses);
                    this.$router
                        .push({ path: `/entities/${this.$route.params.code}/${this.$route.params.id}` });
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка сохранения статусов. ' + error)
                }
            },
            goBack() {
                this.$router
                    .push({ path: `/entities/${this.$route.params.code}/${this.$route.params.id}` });
            },
        },
    };
</script>
